import * as HYPERCUBEJS from '@hypercubejs/hypercubejs';

/**
 * Creates 1080x1080 plane gameobjects.
 * @param {HYPERCUBEJS.Material} [$material] The material to add.
 * @returns {HYPERCUBEJS.Node}
 */
function gameobjectplane1080x1080($material = HYPERCUBEJS.DEFAULTS.material()) {

    const plane1080x1080 = new HYPERCUBEJS.Node('plane1080x1080');
    const meshplane1080x1080 = new HYPERCUBEJS.MeshPlane('meshplane1080x1080', [1080, 1080]);

    meshplane1080x1080.setmaterial($material);
    plane1080x1080.addmesh(meshplane1080x1080);

    plane1080x1080.setcomponent('collideraabb', {

        'type': 'static',

        'min': [-1080 / 2, 0, -1080 / 2],
        'max': [1080 / 2, 0, 1080 / 2]
    });

    return plane1080x1080;
}

export {

    gameobjectplane1080x1080
};

export default gameobjectplane1080x1080;
